export const IS_LOCAL_STORAGE = typeof localStorage !== 'undefined';
